@if (pageCount > 0) {
    <div class="pagination">
        <ng-template #first>
            <span class="page-changer" aria-hidden="true" i18n="@@ngb.pagination.first">&laquo;&laquo;</span>
        </ng-template>
        <ng-template #previous>
            <span class="page-changer" aria-hidden="true" i18n="@@ngb.pagination.previous">
                <img src="../../../assets/img/paginationLeft.svg" alt="pagination" />
            </span>
        </ng-template>
        <ng-template #next>
            <span class="page-changer" aria-hidden="true" i18n="@@ngb.pagination.next">
                <img src="../../../assets/img/paginationRight.svg" alt="pagination" />
            </span>
        </ng-template>
        <ng-template #last>
            <span class="page-changer" aria-hidden="true" i18n="@@ngb.pagination.last">&raquo;&raquo;</span>
        </ng-template>
        <ng-template #ellipsis>
            <span><img src="assets/images/ellipsis.svg" alt="ellipsis" /></span>
        </ng-template>
        <ng-template #defaultNumber let-page let-currentPage="currentPage">
            {{ page }}
        </ng-template>
        <div class="footer-left">
            <div class="custom-dropdown">
                <div class="dropdown-display" (click)="toggleDropdown()">
                    <span>{{ "Show" | translate }} {{ selectedPageSize }}</span>
                    <img src="../../../assets/img/arrowDown.png" class="dropdown-arrow" [class.rotated]="isDropdownOpen" />
                </div>
                @if (isDropdownOpen) {
                    <div class="dropdown-options">
                        <div class="option" (click)="selectOption(10)">{{ "Show" | translate }} 10</div>
                        <div class="option" (click)="selectOption(20)">{{ "Show" | translate }} 20</div>
                        <div class="option" (click)="selectOption(30)">{{ "Show" | translate }} 30</div>
                        <div class="option" (click)="selectOption(40)">{{ "Show" | translate }} 40</div>
                        <div class="option" (click)="selectOption(50)">{{ "Show" | translate }} 50</div>
                    </div>
                }
            </div>
        </div>

        <div class="footer-right">
            <p>Showing {{ startIndex }}-{{ endIndex }} out of {{ collectionSize }}</p>
            <!-- <p>
      {{ 'showing' | translate }} {{ startIndex }}
      {{ 'to' | translate }} {{ endIndex }}
      {{ 'of' | translate }} {{ collectionSize }}
      {{ 'entries' | translate }}
    </p> -->
            <!-- <div class="form-group">
    <select class="form-control" (change)="pageSizeChange.emit($event)">
      <option value="10">{{'show' | translate}} 10</option>
      <option value="20">{{'show' | translate}} 20</option>
      <option value="30">{{'show' | translate}} 30</option>
    </select>
  </div> -->
        </div>

        <ng-template #defaultPages let-page let-pages="pages" let-disabled="disabled">
            @for (pageNumber of pages; track $index) {
                <li
                    class="page-item"
                    [class.active]="pageNumber === page"
                    [class.disabled]="isEllipsis(pageNumber) || disabled"
                    [attr.aria-current]="pageNumber === page ? 'page' : null"
                >
                    @if (isEllipsis(pageNumber)) {
                        <a class="page-link page-number" tabindex="-1" aria-disabled="true">
                            <ng-template
                                [ngTemplateOutlet]="tplEllipsis?.templateRef || ellipsis"
                                [ngTemplateOutletContext]="{ disabled: true, currentPage: page }"
                            />
                        </a>
                    } @else {
                        <a
                            class="page-link page-number"
                            href
                            (click)="selectPage(pageNumber); $event.preventDefault()"
                            [attr.tabindex]="disabled ? '-1' : null"
                            [attr.aria-disabled]="disabled ? 'true' : null"
                        >
                            <ng-template
                                [ngTemplateOutlet]="tplNumber?.templateRef || defaultNumber"
                                [ngTemplateOutletContext]="{ disabled: disabled, $implicit: pageNumber, currentPage: page }"
                            />
                        </a>
                    }
                </li>
            }
        </ng-template>
        <ul [class]="'pagination' + (size ? ' pagination-' + size : '')">
            @if (boundaryLinks) {
                <li class="page-item" [class.disabled]="previousDisabled()">
                    <a
                        aria-label="First"
                        i18n-aria-label="@@ngb.pagination.first-aria"
                        class="page-link"
                        href
                        (click)="selectPage(1); $event.preventDefault()"
                        [attr.tabindex]="previousDisabled() ? '-1' : null"
                        [attr.aria-disabled]="previousDisabled() ? 'true' : null"
                    >
                        <ng-template
                            [ngTemplateOutlet]="tplFirst?.templateRef || first"
                            [ngTemplateOutletContext]="{ disabled: previousDisabled(), currentPage: page }"
                        />
                    </a>
                </li>
            }
            @if (directionLinks) {
                <li class="page-item" [class.disabled]="previousDisabled()">
                    <a
                        aria-label="Previous"
                        i18n-aria-label="@@ngb.pagination.previous-aria"
                        class="page-link"
                        href
                        (click)="selectPage(page - 1); $event.preventDefault()"
                        [attr.tabindex]="previousDisabled() ? '-1' : null"
                        [attr.aria-disabled]="previousDisabled() ? 'true' : null"
                    >
                        <ng-template
                            [ngTemplateOutlet]="tplPrevious?.templateRef || previous"
                            [ngTemplateOutletContext]="{ disabled: previousDisabled() }"
                        />
                    </a>
                </li>
            }
            <ng-template
                [ngTemplateOutlet]="tplPages?.templateRef || defaultPages"
                [ngTemplateOutletContext]="{ $implicit: page, pages: pages, disabled: disabled }"
            />
            @if (directionLinks) {
                <li class="page-item" [class.disabled]="nextDisabled()">
                    <a
                        aria-label="Next"
                        i18n-aria-label="@@ngb.pagination.next-aria"
                        class="page-link"
                        href
                        (click)="selectPage(page + 1); $event.preventDefault()"
                        [attr.tabindex]="nextDisabled() ? '-1' : null"
                        [attr.aria-disabled]="nextDisabled() ? 'true' : null"
                    >
                        <ng-template
                            [ngTemplateOutlet]="tplNext?.templateRef || next"
                            [ngTemplateOutletContext]="{ disabled: nextDisabled(), currentPage: page }"
                        />
                    </a>
                </li>
            }
            @if (boundaryLinks) {
                <li class="page-item" [class.disabled]="nextDisabled()">
                    <a
                        aria-label="Last"
                        i18n-aria-label="@@ngb.pagination.last-aria"
                        class="page-link"
                        href
                        (click)="selectPage(pageCount); $event.preventDefault()"
                        [attr.tabindex]="nextDisabled() ? '-1' : null"
                        [attr.aria-disabled]="nextDisabled() ? 'true' : null"
                    >
                        <ng-template
                            [ngTemplateOutlet]="tplLast?.templateRef || last"
                            [ngTemplateOutletContext]="{ disabled: nextDisabled(), currentPage: page }"
                        />
                    </a>
                </li>
            }
        </ul>
    </div>
}
